export default {

    filtersContainer: {
        display: "flex",
        columnGap: "30px",
        alignItems: "end",
        width:"100%",
        justifyContent:"space-between"
    },
    filterContainerStyles:{
        flexGrow:1
    },
    payerDropdown: {
        margin: "0",
        width: "22%"
    },

    dropdownContainerStyles: {
        margin: "0"
    },

    buttonContainer: {
        display: "flex",
        columnGap: "5px",
    },

    button: {
        padding: "6px 22px"
    },

    actionDropdown: {
        background: "#F8FAFB",
        border: "1px solid #262626",
        borderRadius: "80px",
        padding: "6px 22px",
    },

    actionDropdownLabel: {
        marginRight: "15px"
    },

    actionDropdownMenu: {
        width: "max-content",
        minWidth: "auto",
        left: "-70px",
        top: "29px",
    },

    headerText: {
        display: "flex",
        alignItems: "center",
        columnGap: "10px",
        width:"100%"
    },

    viewingYear: {
        display: "flex",
        alignItems: "center",
        fontWeight: "500"
    },

    searchFilter: {
        display: "flex",
        columnGap: "20px",
        width:'100%',
    },

    filter: {
        display: "flex",
        columnGap: '15px',
        alignItems: "center",
        width:"100%"
    },

}